import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Global Members/HTML Events/GestureEvent";
import * as React from 'react';
export default {
  Content,
  React
};